export function isEventFromForm(e: KeyboardEvent) {
    return (e.target as HTMLElement).closest("form") !== null;
}
